const insurerCodes = {
    WAB: 'Granit',
    KOB: 'Kobe',
    UNI: 'Union',
    COL: 'Colonnade',
    ALL: 'Allianz',
    GEN: 'Generali',
    ALF: 'Alfa',
};

export default function state() {
	return {
		currentContract: null,
		currentPage: 0,
		offer: null,
		insurerCode: null,
		insurerCodes: insurerCodes,
		contractingFormData: {
			baseData: {},
			insuredData: {},
			financingData: {},
		},
		checkboxes: {
            differentInsuredPermanentAddress: false,
			differentPermanentAddress: false,
			differentMailingAddress: false,
			differentInsuredData: false,
			differentInsuredMailingAddress: false,
			firstInsuredDataIsContract: false,
			allFilesAccepted: false,
            privacyAccept: null,
            terminationAuthorizationAccepted: null,
			canFinalize: false,
			kobeMember: false,
			unionDm: false,
			unionEContract: false,
			unionDashboard: false,
			buildingStatus: null,
            euroriskMarketing: null,
            mailingAddressNotHasHouseNumber: false,
            permanentAddressNotHasHouseNumber: false,
            insuredMailingAddressNotHasHouseNumber: false,
            insuredPermanentAddressNotHasHouseNumber: false,
			statements: {
				WAB: {
					WABNY1: false,
					WABNY2: false,
				},
				COL: {
					COLNY_BIZTF: false,
					COLNY_HIRL: false,
					COLNY_ADVED: false,
					COLNY_TUDV: false,
					COLNY_VALAD: false,
				},
				KOB: {
					KOB_ADATCS: false,
					KOB_JOGSZAB: false,
					KOB_ADATKEZ: false,
					KOB_TAVERT: true,
				},
				UNI: {
					UNI_1: false,
					UNI_2: false,
					UNI_3: false,
					UNI_4: false,
					UNI_5: false,
				},
				ALL: {
					UGYFPORTAL: false,
					UGYFELTAJ: false,
					KARMENTESSEG: null,
					SZEMADAT: false,
					ZALOGKOT: false,
					AJANLATTETEL: false,
					MARKETING: false,
				},
				GEN: {
					ESZAMLA: false,
					DOK1: false,
					DOK2: null,
					DOK3: false,
					DOK4: false,
					DOK5: false,
					KOZVNY: false,
					MARKETING: false,
				},
                ALF: {
                    MARKETING_NY: false,
                },
			},
		},
		offerResponse: {},
		brokerageData: {
			contract_id: null,
			pdf: null,
            type: null,
            newType: null,
		},
		financers: null,
		banks: null,
		wsErrors: [],
		damageEvent: null,
		damageCount: 0,
		damageAmount: null,
		disabledInputs: [],
		inited: false,
        summary: null,
	};
}
